import { render, staticRenderFns } from "./GradeChart.vue?vue&type=template&id=2950b833&scoped=true&"
import script from "./GradeChart.vue?vue&type=script&lang=js&"
export * from "./GradeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950b833",
  null
  
)

export default component.exports